import { render, staticRenderFns } from "./editConsumer.vue?vue&type=template&id=4ffb13d9&scoped=true&"
import script from "./editConsumer.vue?vue&type=script&lang=js&"
export * from "./editConsumer.vue?vue&type=script&lang=js&"
import style0 from "./editConsumer.vue?vue&type=style&index=0&id=4ffb13d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb13d9",
  null
  
)

export default component.exports